
import { HttpClient,  } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxCurrencyInputMode } from 'ngx-currency';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

// AoT requires an exported function for factories
registerLocaleData(localePt, 'pt');

export const customCurrencyMaskConfig = {
    align: "left",
    allowNegative: false,
    allowZero: true,
    decimal: ",",
    precision: 2,
    prefix: "R$ ",
    suffix: "",
    thousands: ".",
    nullable: true,
    inputMode: NgxCurrencyInputMode.Financial
};


